/* eslint-disable prettier/prettier */
import React from 'react';
import TeamsTableRow from "./TeamsTableRow";
import _ from "lodash";
import {useTeamFilterOptions} from "../FilterOptions/TeamFilterOptions";
import FrontPageTablesRow from "../../StandingsTableRow";
import {useTeamsStats} from "../../../hooks/teamStats";

function TeamsTable( {season, orderBy}) {
    const [teamsStats, teamsStatsLoading, teamsStatsError] = useTeamsStats(season);
    const sortedTeams = _.orderBy(teamsStats,orderBy, 'desc');
    if (sortedTeams.length && !teamsStatsLoading) {
        return sortedTeams?.filter((x) => x.abbrv !== undefined).map((team, i) => (
            <TeamsTableRow team={team} i={i + 1} orderBy={orderBy}></TeamsTableRow>
        ));
    }
    else if (teamsStatsLoading) {
        return (
            <div className='stats-table__row'>
                <div className="col-12 text-center stats-font-larger">Loading...</div>
            </div>
        );
    } else {
        return (
            <div className='stats-table__row'>
                <div className="col-12 text-center stats-font-larger">Ingen data tillgänglig.</div>
            </div>
        );
    }

}
export default TeamsTable;